/* eslint valid-typeof: "off" */
import { types } from '../constants';

/**
 * Assembles an object from a query string using the validationMap as a guide
 * @param queryString {string} - A query string
 * @param validationMap {object} - An object whose keys are valid qs vars,
 * and whose values are objects containing `type` and `default` keys
 * @returns {object} - The parsed and validated query string
 */
function parseQueryString(queryString = '', validationMap) {

  if (!String(queryString).match(/^\?/)) return {};

  return queryString
    .replace('?', '')
    .split('&')
    .map((val) => {
      if (!val.includes('=')) {
        return null;
      }

      const [ key, value ] = val.split('=');

      // If there's no validationMap, all params are considered valid.
      if (typeof validationMap !== types.OBJECT || Object.keys(validationMap).length === 0) {
        return { [key]: value };
      }

      if (!Object.prototype.hasOwnProperty.call(validationMap, key)) {
        return null;
      }

      if (validationMap[key].type === types.BOOLEAN && (value === 'true' || value === 'false')) {
        return { [key]: value === 'true' };
      } else if (validationMap[key].type === types.NUMBER && !isNaN(Number(value))) {
        return { [key]: Number(value) };
      } else if (validationMap[key].type === types.STRING) {
        return { [key]: value };
      }

      // Invalid type
      return null;
    })
    .filter(val => val !== null)
    .reduce((acc, val) => Object.assign({}, acc, val), {});
}

export default parseQueryString;
